import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react'

import Link from 'next/link'
import { usePageTransition } from '@/components/generals/transition-provider'

interface TransitionLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    href: string
    children: ReactNode
}

const TransitionLink = ({ href, onClick, target, children, ...rest }: TransitionLinkProps): ReactNode => {
    const { navigate } = usePageTransition()

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event)

        if (event.defaultPrevented) return
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
        if (target && target !== '_self') return
        if (!href.startsWith('/')) return

        event.preventDefault()
        navigate(href)
    }

    return (
        <Link href={href} target={target} onClick={handleClick} {...rest}>
            {children}
        </Link>
    )
}

export default TransitionLink
